import React, { createContext, useCallback, useContext, useRef } from "react";

export type PostType = "classPost" | "assignmentPost";
type OpenForPostFn = (
  postUid: string,
  postType: PostType,
  postTitle: string,
) => void;

interface MessageTeacherContextValue {
  openForPost: OpenForPostFn;
  registerOpenForPost: (fn: OpenForPostFn) => void;
}

const MessageTeacherContext = createContext<MessageTeacherContextValue>({
  openForPost: () => {},
  registerOpenForPost: () => {},
});

export function MessageTeacherProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const fnRef = useRef<OpenForPostFn>(() => {});

  const registerOpenForPost = useCallback((fn: OpenForPostFn) => {
    fnRef.current = fn;
  }, []);

  const openForPost = useCallback<OpenForPostFn>(
    (postUid, postType, postTitle) => {
      fnRef.current(postUid, postType, postTitle);
    },
    [],
  );

  return (
    <MessageTeacherContext.Provider
      value={{ openForPost, registerOpenForPost }}
    >
      {children}
    </MessageTeacherContext.Provider>
  );
}

export function useMessageTeacher() {
  return useContext(MessageTeacherContext);
}
